import React from "react";
import { Button, Input, Dropdown, Menu } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useAppointmentModel } from "../appointmentModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useAppointmentDetailsModel } from "./details/appointmentDetailsModel";
import { AuthButton } from "@/components/auth/AuthButton"
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "@/views/base/dict/dictModel";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
import { DownOutlined } from "@ant-design/icons";
import { formatNum } from "@/utils/utils";

export const DataBox = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, rolesAllList, setLocale } = useGlobalModel();
    const Locale = setLocale(LanguageArr)
    const { selectedRowKeys, selectedRow, invalidateData, detailsExport, Transfer, listExport,descTotal,rowsDescTotal } = useAppointmentModel();
    const { setDetailEditForm, setDetailItemEditList, setDetailMaterialEditList } = useAppointmentDetailsModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const { getTreeNodeOne } = useDictModel();

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        if (selectedRow.status === "appointment.change") {
            // globalPrompt("message", { text: "该单据已作废，无法进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["The document is invalid and cannot be edited."], type: "warning" });
            return;
        }
        let saleSoEditKey = "2-1-2";
        let isFindNav = findNav(saleSoEditKey);
        if (!isFindNav) {
            addNav(saleSoEditKey, { id: selectedRow.appointmentCode as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                // title: "维修单跳转详情",
                title: Locale["Jump to the detail page of maintenance doc."],
                type: "warning",
                // text: "您还有维修单详情未保存，是否跳转",
                text: Locale["The detail page of maintenance doc has not been saved. Do you still want to jump?"],
                // okText: "跳转未保存页",
                okText: Locale["Jump to the unsaved page"],
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                // cancelText: "打开新页签",
                cancelText: Locale["Open a new page"],
                onCancel: () => {
                    switchNavState(saleSoEditKey, { id: selectedRow.appointmentCode as string, mode: "edit" });
                    setDetailEditForm({});
                    setDetailItemEditList([]);
                    setDetailMaterialEditList([])
                    // updateEditFormVal(null);
                }
            })
        }
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行查看", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data to view."], type: "warning" });
            return;
        }
        let supplierEditKey = "2-1-3";
        replaceNav(
            selectedNavId,
            "2-1-3",
            { id: selectedRow.appointmentCode as string, mode: "look", },
            true
        );
    }
    const cancellation = async () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行作废", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for cancellation."], type: "warning" });
            return;
        }
        let val: string = ""
        globalPrompt("modal", {
            // title: "维修单作废",
            title: Locale["Cancel the maintenance doc."],
            type: "error",
            // text: "",
            text: <><span>{Locale["Please enter your reason for cancellation"]}</span>
                <Input onChange={(e) => { val = e.target.value }} /></>,
            // okText: "确定",
            okText: Locale["Yes No"],
            onOk: () => {
                let obj = {
                    id: selectedRow.id,
                    appointmentCode: selectedRow.appointmentCode,
                    cancelReason: val
                    // val
                }
                invalidateData(obj)
            },
            // cancelText: "取消",
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })
    }
    const onTransfer = async () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        let retData = await Transfer()
        if (retData) {
            // globalPrompt("message", { text: "转维修单成功", type: "success" });
            globalPrompt("message", { text: Locale["Successfully transferred to maintenance doc"], type: "success" });
            addNav("2-2")

        } else {
            // globalPrompt("message", { text: "转维修单失败", type: "error" });
            globalPrompt("message", { text: Locale["Unsuccessfully transferred to maintenance doc"], type: "success" });

        }
    }
    const MenuExport = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={listExport}>{Locale["List export"]}</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={detailsExport}>{Locale["Details export"]}</span>
                </Menu.Item>
            </Menu>
        )
    }
    const action = <>
        <AuthButton
            // resCode="appointmentAdd"
            resCode={ResourcesAuthBtn[mianCode]["AppointmentAdd"]}
            onClick={() => addNav("2-1-1", { id: "", mode: "add" })}
            name={Locale["Add"]}
        />
        <AuthButton
            // resCode="appointmentEdit"
            resCode={ResourcesAuthBtn[mianCode]["AppointmentEdit"]}
            onClick={onEdit}
            // name="编辑"
            name={Locale["Edit"]}
        />
        <AuthButton
            // resCode="appointmentView"
            resCode={ResourcesAuthBtn[mianCode]["AppointmentView"]}
            onClick={onLook}
            // name="查看"
            name={Locale["View"]}
        />
        <AuthButton
            // resCode="appointmentTransfertoMaintenance"
            resCode={ResourcesAuthBtn[mianCode]["AppointmentTransfertoMaintenance"]}
            onClick={onTransfer}
            // name="转维修"
            name={Locale["Transfer to Maintenance"]}
        />
        <AuthButton
            // resCode="appointmentCancel"
            resCode={ResourcesAuthBtn[mianCode]["AppointmentPrint"]}
            onClick={cancellation}
            // name="作废"
            name={Locale["Cancel"]}
        />
        <Dropdown overlay={MenuExport}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
            >{Locale["export"]}<DownOutlined /></Button>
        </Dropdown>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => addNav("2-1-1", { id: "", mode: "add" })}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >编辑</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onLook}
        >查看</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onTransfer}
        >转维修</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={cancellation}
        >作废</Button> */}
    </>;

const desc: IDescription[] = [
    {
        // label: "预约工时费",
        label: Locale["Estimated Labor Cost"],
        value: selectedRowKeys.length === 0 ? descTotal.workingHoursAmount : formatNum(rowsDescTotal.workingHoursAmount),
        color: DescriptionColorEnum.red
    },
    {
        // label: "预计材料费",
        label: Locale["Estimated Material Cost"],
        value: selectedRowKeys.length === 0 ? descTotal.materialScienceAmount : formatNum(rowsDescTotal.materialScienceAmount),
        color: DescriptionColorEnum.red
    },
    {
        // label: "费用合计",
        label: Locale["Total Amount"],
        value: selectedRowKeys.length === 0 ? descTotal.totalAmount : formatNum(rowsDescTotal.totalAmount),
        color: DescriptionColorEnum.red
    },
    {
        // label: "预计工时",
        label: Locale["Estimated Man-hours"],
        value: selectedRowKeys.length === 0 ? descTotal.workHour : formatNum(rowsDescTotal.workHour),
        color: DescriptionColorEnum.red
    },
]
return (
    <YhBox title={<></>} descriptions={desc} action={action} >
            <DataTable />
        </YhBox>
    )
}